import { Component, OnInit, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { ConfigurationService } from '../_services/configuration.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig } from '../_helpers/index';
import { ICustomer, DebtorsPatchRequest } from '../_models/customer.interface';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { notificationStatus, notificationType } from '../_enums/index';
import { Configuration } from '../_models';

@Component({
  selector: 'notification/list',
  templateUrl: './notificationlist.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})
export class NotificationListComponent implements OnInit {
  public notificationForm: FormGroup;
  public notificationEditForm: FormGroup;

  public customer_public_id: string;
  excelExportData: any;
  ddlnotificationtype: any[];
  ddlnotificationStatus: any[];
  public custNotifyTemplateList: any;
  public custNotifyFilterTemplateList: any;

  auth0Profile: any;

  searchFilterForm: FormGroup;
  displayedColumns: string[] = ['created', 'name', 'template_id', 'status', 'actions'];
  dataSource = new MatTableDataSource();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  filterValue;
  public iCustomer: ICustomer;
  debtorsPatchRequest: DebtorsPatchRequest[] = [];

  pageSize: number;
  PageSizeOptions: number[];

  isLoading = true;
  notification_publicid: any;
  valueSlide = -30;
  public valueEdit: any;
  // notificationValue: any;
  selectorValue: any;
  notificationList = [];
  status: any = "All";
  isLimit: boolean = false;
  isLimitInEdit: boolean = false;

  templateListLimit: number = 100;

  constructor
    (
      private customerService: CustomerService
      , private configurationService: ConfigurationService
      , private _fb: FormBuilder
      , private router: Router
      , private spinnerService: Ng4LoadingSpinnerService
      , private _notificationType: notificationType
      , private _notificationStatus: notificationStatus
    ) {
    this.spinnerService.show();

    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;

    this.ddlnotificationtype = _notificationType.dbtType;
    this.ddlnotificationStatus = _notificationStatus.Status;
  }

  applyFilter() {
    this.filter();
  }

  /**
* this Initial Setup function is used to initialize the form controls
**/
  InitialSetupCreateForm() {
    this.notificationForm = this._fb.group({
      name: new FormControl("", Validators.required),
      description: new FormControl("", Validators.required),
      status: new FormControl("ACTIVE"),
      object_related: new FormControl("INVOICE"),
      type: new FormControl("NOTIFICATION"),
      customer: this._fb.group({
        public_id: new FormControl(this.customer_public_id)
      }),
      values: this._fb.group({
        days: new FormControl(0, [Validators.required, Validators.min(0), Validators.max(180)]),
        hours: new FormControl(0, [Validators.required, Validators.min(0), Validators.max(23)]),
        minutes: new FormControl(0, [Validators.required, Validators.min(0), Validators.max(59)]),
        selector: new FormControl("1"),
        template_id: new FormControl("", Validators.required)
      })
    });
  }

  InitialSetup() {

    this.notificationEditForm = this._fb.group({
      id: new FormControl(""),
      name: new FormControl("", Validators.required),
      description: new FormControl("", Validators.required),
      status: new FormControl("Activo"),
      object: new FormControl(""),
      object_related: new FormControl("INVOICE"),
      public_id: new FormControl(""),
      type: new FormControl("NOTIFICATION"),
      values: this._fb.group({
        days: new FormControl(0, [Validators.required, Validators.min(0), Validators.max(180)]),
        hours: new FormControl(0, [Validators.required, Validators.min(0), Validators.max(23)]),
        minutes: new FormControl(0, [Validators.required, Validators.min(0), Validators.max(59)]),
        selector: new FormControl("1"),
        template_id: new FormControl("", Validators.required)
      })
    });


  }
  ngOnInit() {

    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');

      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');

    }

    this.InitialSetupCreateForm();
    this.InitialSetup();
    this.getCustomerNotificationTemplateList(this.customer_public_id);



    this.searchFilterForm = this._fb.group({
      searchText: ['', Validators.required]
    });

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";

    this.GetCustomerNotificationDetails();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.observerCreationForm();
    this.observerEditForm();
  }

  observerCreationForm() {
    this.notificationForm.get('values.days').valueChanges.subscribe({
      next: day => {
        if (day >= 180) {
          this.isLimit = true;
          this.notificationForm.get('values.hours').setValue(0);
          this.notificationForm.get('values.minutes').setValue(0);
        } else {
          this.isLimit = false;
        }
      }
    });
  }

  observerEditForm() {
    this.notificationEditForm.get('values.days').valueChanges.subscribe({
      next: day => {
        if (day >= 180) {
          this.isLimitInEdit = true;
          this.notificationEditForm.get('values.hours').setValue(0);
          this.notificationEditForm.get('values.minutes').setValue(0);
        } else {
          this.isLimitInEdit = false;
        }
      }
    });
  }

  GetCustomerNotificationDetails() {
    this.configurationService.getConfigurationList(this.customer_public_id, "INVOICE", "NOTIFICATION").subscribe(data => {
      this.isLoading = false;
      let resources = data["data"];
      this.dataSource.data = resources;
      this.notificationList = resources;
      this.excelExportData = resources;
      this.spinnerService.hide();
    },
      error => {
        this.isLoading = false;

      });
  }

  changeValue(event) {
    this.valueSlide = event.value;

  }

  editNotificationDetails(element) {
    this.InitialSetup();
    this.notification_publicid = element.public_id;
    this.configurationService.getConfiguration(this.notification_publicid).subscribe({
      next: (data: Configuration) => {
        this.valueEdit = data.values.days;
        if (data.values.selector == undefined) {
          if (data.values.days >= 0) {
            this.selectorValue = "2"
          }
          if (data.values.days < 0) {
            this.selectorValue = "1"
          }
        } else {
          this.selectorValue = data.values.selector;
        }

        if (data.values.days === 180) {
          this.isLimitInEdit = true;
        } else {
          this.isLimitInEdit = false;
        }

        this.notificationEditForm = this._fb.group({
          id: new FormControl(data.id),
          name: new FormControl(data.name),
          description: new FormControl(data.description),
          status: new FormControl(data.status),
          object: new FormControl(data.object),
          object_related: new FormControl(data.object_related),
          public_id: new FormControl(data.public_id),
          type: new FormControl(data.type),

          values: this._fb.group({
            days: new FormControl(Math.abs(data.values.days), [Validators.required, Validators.min(0), Validators.max(180)]),
            hours: new FormControl(data.values.hours, [Validators.required, Validators.min(0), Validators.max(23)]),
            minutes: new FormControl(data.values.minutes, [Validators.required, Validators.min(0), Validators.max(59)]),
            template_id: new FormControl(data.values.template_id),
            selector: new FormControl(this.selectorValue)
          })
        });
      },
      complete: () => {
        this.observerEditForm()
      }
    })
  }//end

  getCustomerNotificationTemplateList(public_id: string) {

    this.customerService.getCustomerNotificationTemplateList(this.customer_public_id, this.templateListLimit)
      .subscribe(data => {
        if (data && Array.isArray(data)) {
          this.custNotifyTemplateList = data;
          this.custNotifyFilterTemplateList = this.custNotifyTemplateList;
        } else {
          this.custNotifyTemplateList = [];
          this.custNotifyFilterTemplateList = [];
        }
      }, error => {
        this.custNotifyTemplateList = [];
        this.custNotifyFilterTemplateList = [];
      });
  }


  onsubmitNotificationForm({ value }: { value: Configuration }) {
    this.spinnerService.show();
    value.customer.public_id = this.customer_public_id;
    this.configurationService.createConfiguration(value)
      .subscribe((result) => {
        this.InitialSetupCreateForm();
        this.isLimit = false;
        this.observerCreationForm();
        setTimeout(() => {
          this.GetCustomerNotificationDetails();
        }, 2000);
      }, error => {
        console.log('Failed while trying to save the Notification Template Details.' + error);
      });


  }//end method

  onupdateNotificationForm({ value }: { value: Configuration }) {
    this.spinnerService.show();
    //value.values = {'days': -10,'template_id':"tmp_dev_iJ7aqqtmHotBAV3x4YgXaG"}
    this.configurationService.updateConfiguration(value, this.notification_publicid)
      .subscribe((result) => {
        if (result.status == "201" || result.status == "400") {
          this.getCustomerNotificationTemplateList(this.customer_public_id);

        }
        setTimeout(() => {
          this.GetCustomerNotificationDetails();
        }, 2000);
        this.InitialSetup();
        this.isLimitInEdit = false;
        this.observerEditForm();
      }, error => {

        console.log('Failed while trying to save the Notification Template Details.' + error);
      });


  }//end method


  filterStatusDetails(status) {
    if (status == 'TODOS') {
      this.status = "All"
    } else {
      this.status = status;
    }
    this.filter();

  }

  filter() {
    var tempFilterData = this.notificationList;
    if (this.status != "All") {
      tempFilterData = tempFilterData.filter(data => data.status == this.status)
    }

    if (this.searchFilterForm.controls.searchText.value.length > 0) {
      var serachValue = this.searchFilterForm.controls.searchText.value.trim();
      tempFilterData = tempFilterData.filter(data => data.name.toLowerCase().includes(serachValue.toLowerCase()))
    }

    this.dataSource.data = tempFilterData;
    this.paginator.firstPage();
  }

  getTemplateName(idValue) {

    if (this.custNotifyTemplateList === undefined) {
      return "";
    }
    else {
      this.custNotifyFilterTemplateList = this.custNotifyTemplateList.filter(t => (t === 'undefined') ? "" : t);

      this.custNotifyFilterTemplateList = this.custNotifyTemplateList.filter(t => t.public_id == idValue);


      if (this.custNotifyFilterTemplateList.length == 1 && this.custNotifyTemplateList[0] !== undefined && this.custNotifyTemplateList[0] != null) {
        return this.custNotifyFilterTemplateList[0].name;
      }
      else {
        return "";
      }

    }

  }

  leadingZeros(input) {
    if (!isNaN(input.value) && input.value.length === 1) {
      input.value = '0' + input.value;
    }
  }


}//end class


